import React from 'react';
import { Button, refreshView, TopToolbar, useCreate, useNotify } from 'react-admin';
import { useDispatch } from 'react-redux';
import ActivateIcon from '@material-ui/icons/LockOpen';
import CancelIcon from '@material-ui/icons/Cancel';
import LockVoucher from './LockVoucher';

export default ({ data }) => {
	const notify = useNotify();
	const dispatch = useDispatch();
	const [invoiceVouchers] = useCreate('invoiceVouchers');

	const handleAction = (method) => {
		invoiceVouchers(
			{
				payload: {
					id: data.id,
					method: method,
				},
			},
			{
				onSuccess: () => {
					notify('resources.invoiceVouchers.notifications.successfullyUpdated');
					dispatch(refreshView());
				},
				onFailure: (error) => {
					notify(error.message, 'error');
				},
			},
		);
	};

	const activate = () => {
		handleAction('activate');
	};

	const cancel = () => {
		handleAction('cancel');
	};

	const unlock = () => {
		handleAction('unlock');
	};

	if (data) {
		return (
			<TopToolbar>
				<LockVoucher record={data} />
				<Button label="resources.invoiceVouchers.actions.unlock" component="button" color="primary" onClick={unlock} disabled={data.status !== 'Locked'}>
					<ActivateIcon />
				</Button>
				<Button label="resources.invoiceVouchers.actions.cancel" component="button" color="primary" onClick={cancel} disabled={data.status === 'Cancelled' || data.status === 'Redeemed' || data.status === 'Locked'}>
					<CancelIcon />
				</Button>
				<Button label="resources.invoiceVouchers.actions.activate" component="button" color="primary" onClick={activate} disabled={data.status !== 'Created'}>
					<ActivateIcon />
				</Button>
			</TopToolbar>
		);
	}
};
